export class ArticleFamilyConstants {
  public static PEC: string = 'PEC';
  public static HUB: string = 'HUB';
  public static LDOCLITE: string = 'LDOCLITE';
  public static LEGALINVOICE: string = 'LEGALINVOICE';
  public static SMARTSIGN: string = 'SMART.SIGN';
  public static SIGN: string = 'SIGN';
  public static TIMESTAMP: string = 'TIMESTAMP';
  public static SD: string = 'SD';
  public static FIF: string = 'FIF';
  public static ARF: string = 'ARF';
  public static ID: string = 'ID';
  public static TOKEN_NOVA: string = 'TOKEN.NOVA';
  public static TOKEN: string = 'TOKEN';
  public static VIRTUAL_NOVA: string = 'VIRTUAL.NOVA';

}
